import { Protocol } from '../Protocol';

export class MonitorProtocol {
  public static readonly GET_MONITOR_AREA: string = `${Protocol.YATUNG_API_ROOT}/monitor/area`;
  public static readonly GET_MONITOR_FACTORY: string = `${Protocol.YATUNG_API_ROOT}/monitor/area`;
  public static readonly GET_MONITOR_CUSTOMER: string = `${Protocol.YATUNG_API_ROOT}/monitor/factory`;
  public static readonly GET_MONITOR_SHIPMENT: string = `${Protocol.YATUNG_API_ROOT}/monitor/factory`;
  public static readonly SEARCH_CUSTOMER: string = `${Protocol.YATUNG_API_ROOT}/monitor/factory`;
}
